import React, { useEffect, useRef } from 'react';
import { useConnection } from '../hooks/useConnection';
import { LiveKitRoom, RoomAudioRenderer, StartAudio } from '@livekit/components-react';
import Playground from './Playground';

const LiveKitConnected = ({ component }) => {
    const { shouldConnect, wsUrl, token, connect, disconnect } = useConnection();
    const liveKitAudioRef = useRef(null);
    const mode = component === 'PracticeRoom' ? 'practice' : 'interview';

    useEffect(() => {
        if (!token) connect(mode);
    }, [token, connect, mode]);

    if (!token || !wsUrl) return <div>Connecting...</div>;

    return (
        <LiveKitRoom
            className="flex flex-col display-flex-desktop"
            style={{ size: '100%' }}
            serverUrl={wsUrl}
            token={token}
            connect={shouldConnect}
            onError={(e) => console.error(e)}
            audio={true}
            video={true}
        >
            <Playground component={component} disconnect={disconnect} />
            <RoomAudioRenderer ref={liveKitAudioRef} />
            <StartAudio label="Enable Audio" />
        </LiveKitRoom>
    );
};

export default LiveKitConnected;
